import pre_designed_template1 from "../../../assests/Images/TemplateElement/pre_designed_template1.png";
import { DATE } from "../../../shared/constants.js";
import CardTemplate from "./CardTemplate";

function PreDefineTemplate1({ heading, date, journalId,pageRefresh,ref,menuShow }) {
  return (
    <CardTemplate
      journalId={journalId}
      headingText={heading}
      date={date || DATE.JOURNAL_FORMAT}
      bgColor="#0ae2cd"
      headingColor="#ffffff"
      textColor="#000000"
      textSize={{ xs: "0.8rem", sm: "1rem", md: "1rem" }}
      imageTopLeft={pre_designed_template1}
      imageTopLeftStyle={{ width: 70, height: 70, top: 10, left: 10, transform: "rotate(150deg)" }}
      headingMargin={{ xs: "35%", sm: "40%", md: "40%" }}
      pageRefreshCallback={pageRefresh}
      ref={ref}
      menuShow={menuShow}
    />
  );
}

export default PreDefineTemplate1;
